import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _toConsumableArray from '/app/node_modules/babel-runtime/helpers/toConsumableArray';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _Object$assign from '/app/node_modules/babel-runtime/core-js/object/assign';
//
//
//
//

import axios from '~/plugins/axios';
import serialize from '~/plugins/serialize';

import PageWrap from '~/components/pages/PageWrap.vue';

export default {
	name: 'page-container',
	middleware: ['lang'],
	components: { PageWrap: PageWrap },
	scrollToTop: true,

	head: function head() {

		var globalHead = this.$store.state.settings._head || {},
		    localHead = this.page._head || {},
		    globalTitle = globalHead.title,
		    localTitle = localHead.title || this.page.title,
		    res = {};
		if (this.page.code == 'page-catalog' && this.$route.query.tag) {
			var currentCat = false;
			var tag = this.$route.query.tag;
			this.page.tagNav.forEach(function (item, i, arr) {
				if (item.tag == tag) {
					currentCat = item;
				}
			});
			if (currentCat !== false) {
				try {
					localHead = currentCat._head;
					localTitle = currentCat._head.title;
					//
					this.page.h1 = currentCat.h1;
					this.page.content = currentCat.content;
				} catch (e) {}
			}
		}
		if (this.page.code == 'page-catalog' && this.$route.query.filter) {
			var filters = this.$route.query.filter.split(','),
			    _tag = this.$route.query.tag,
			    vkus = void 0,
			    ves = void 0,
			    vesTitle = '',
			    vkusTitle = '',
			    lin = void 0,
			    linTitle = '';

			this.page.filter.forEach(function (e, i) {
				if (i == 0) ves = e.tags.find(function (i) {
					return filters.find(function (s) {
						return s == i.tag;
					});
				});
				if (i == 1) vkus = e.tags.find(function (i) {
					return filters.find(function (s) {
						return s == i.tag;
					});
				});
			});
			lin = this.page.tagNav.find(function (i) {
				return i.tag == _tag;
			});
			if (ves) vesTitle = ' вес ' + ves.title;
			if (vkus) vkusTitle = ' вкус ' + vkus.title;
			if (lin) linTitle = ' "' + lin.title + '"';

			localHead.title = 'Печенье ' + linTitle + vkusTitle + vesTitle;
		}

		var meta = _Object$assign(localHead.meta, globalHead.meta);
		if (meta.length == 0) {
			meta = {};
		}
		res.meta = meta;

		/*Object.keys(localHead).forEach((el) => {
  
  	if ( Array.isArray(localHead[el]) && Array.isArray(res[el]) ) {
  		res[el] = res[el].concat(localHead[el])
  	}
  	else {
  		res[el] = localHead[el]
  	}
  		})
  
  Object.keys(globalHead).forEach((el) => {
  	
  	if ( Array.isArray(globalHead[el]) && Array.isArray(res[el]) ) {
  		res[el] = res[el].concat(globalHead[el])
  	}
  	else {
  		res[el] = globalHead[el]
  	}
  	})*/
		var finaltitle = void 0;
		finaltitle = localTitle;
		res.title = finaltitle ? '' + finaltitle : globalTitle;

		if (res.meta.Description == undefined) {
			res.meta.Description = {};
			res.meta.Description.content = res.title;
			res.meta.Description.hid = 'Description';
			res.meta.Description.name = 'Description';
		}
		return res;
	},
	data: function data() {
		return {
			page: {}
		};
	},
	asyncData: function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
			var params = _ref.params,
			    query = _ref.query,
			    error = _ref.error,
			    req = _ref.req;

			var urlpath, _ref3, data, items, vacancy, currentCat, tag, filters, _tag2, vkus, ves, vesTitle, vkusTitle, lin, linTitle, allfilters;

			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.prev = 0;

							/*var url = req.path;
       var url_arr = url.split('/').slice(1);
        	if(url_arr[0] == 'eng'){
        		params.lang = 'en';
        		params.page = url_arr[1];
        		params.inner = url_arr[2];
        	}else{
        		params.lang = 'ru';
        	} 			*/
							if (params.page == 'robots.txt') {
								urlpath = 'robots/';
							} else {
								urlpath = 'page/' + (params.page || 'home') + '/' + (params.lang || 'ru');
							}

							_context.next = 4;
							return axios.get(urlpath);

						case 4:
							_ref3 = _context.sent;
							data = _ref3.data;

							if (!data.pagination) {
								_context.next = 11;
								break;
							}

							_context.next = 9;
							return axios.get('paginate/' + params.page + '/' + params.lang);

						case 9:
							items = _context.sent;

							data.itemsData = items.data;

						case 11:
							data.urlpath_page = urlpath;

							if (!query.vacancy) {
								_context.next = 17;
								break;
							}

							_context.next = 15;
							return axios.get('vacancy?code=' + query.vacancy);

						case 15:
							vacancy = _context.sent.data;

							data.vacancy = vacancy;

						case 17:

							if (data.code == 'page-catalog' && query.tag) {
								currentCat = false;
								tag = query.tag;

								data.tagNav.forEach(function (item, i, arr) {
									if (item.tag == tag) {
										currentCat = item;
									}
								});
								if (currentCat !== false) {
									try {
										data._head = currentCat._head;
										data.h1 = currentCat.h1;
										data.content = currentCat.content;
									} catch (e) {}
								}
							}
							if (data.code == 'page-catalog' && query.filter) {
								filters = query.filter.split(','), _tag2 = query.tag, vkus = void 0, ves = void 0, vesTitle = '', vkusTitle = '', lin = void 0, linTitle = '';
								allfilters = [];

								data.filter.forEach(function (e, i) {
									allfilters.push.apply(allfilters, _toConsumableArray(e.tags));
								});
								filters.forEach(function (e, i) {
									if (!allfilters.find(function (el) {
										return el.tag == e;
									})) {
										throw { response: { status: 404, data: 'filter no found' } };
									}
								});
								data.filter.forEach(function (e, i) {
									if (i == 0) {
										ves = e.tags.find(function (ii) {
											return filters.find(function (s) {
												return s == ii.tag;
											});
										});
									}
									if (i == 1) {
										vkus = e.tags.find(function (ii) {
											return filters.find(function (s) {
												return s == ii.tag;
											});
										});
									}
								});
								//
								lin = data.tagNav.find(function (i) {
									return i.tag == _tag2;
								});
								if (ves) vesTitle = ' вес ' + ves.title;
								if (vkus) vkusTitle = ' вкус ' + vkus.title;
								if (lin) linTitle = ' "' + lin.title + '"';

								data._head.title = 'Печенье ' + linTitle + vkusTitle + vesTitle;
							}
							if (data.code == 'page-robots') {
								data.host = 'Host: ' + req.headers.host;
								data.sitemap = 'Sitemap: http://' + req.headers.host + '/sitemap.xml';
							}

							return _context.abrupt('return', { page: data });

						case 23:
							_context.prev = 23;
							_context.t0 = _context['catch'](0);

							error({ statusCode: _context.t0.response.status, message: _context.t0.response.data });

						case 26:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this, [[0, 23]]);
		}));

		function asyncData(_x) {
			return _ref2.apply(this, arguments);
		}

		return asyncData;
	}(),


	methods: {
		getPaginate: function () {
			var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
				var items;
				return _regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return axios.get('paginate/' + this.$route.params.page + '/' + (this.$route.params.lang || 'ru') + '?' + serialize(this.$route.query));

							case 2:
								items = _context2.sent;

								this.page.itemsData = items.data;

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function getPaginate() {
				return _ref4.apply(this, arguments);
			}

			return getPaginate;
		}()
	},
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		// вызывается до подтверждения пути, соответствующего этому компоненту.
		// НЕ ИМЕЕТ доступа к контексту экземпляра компонента `this`,
		// так как к моменту вызова экземпляр ещё не создан!

		var url_arr = to.path.split('/').slice(1);
		for (var i in url_arr) {
			if (url_arr[i] == '') url_arr[i] = undefined;
		}
		if (url_arr[0] == 'eng') {
			to.params.lang = 'en';
			to.params.page = url_arr[1];
			to.params.inner = url_arr[2];
		} else {
			to.params.lang = 'ru';
		}
		next();
	},
	beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
		if (!this.$route.params.inner) this.page.prevPagePath = from.fullPath;

		next();
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_page.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_page.vue
// module chunks = 0